const STORAGE_KEY = 'clixyads_ref'
const MAX_AGE_MS = 30 * 86400_000 // 30 días

// Captura ?ref=CODIGO de la URL y lo guarda con TTL
export function captureRefFromUrl() {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  if (ref && /^[A-Za-z0-9]{4,16}$/.test(ref)) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: ref.toUpperCase(), t: Date.now() }))
    } catch {}
  }
}

// Devuelve el ref code guardado o null si caducó
export function getStoredRefCode() {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed?.code || !parsed?.t) return null
    if (Date.now() - parsed.t > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return parsed.code
  } catch {
    return null
  }
}

export function clearRefCode() {
  try { localStorage.removeItem(STORAGE_KEY) } catch {}
}
